import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState } from './user.state';

const selectUser = createFeatureSelector<UserState>('user');

export const userSelectorCurrentUser = createSelector(
    selectUser,
    (state: UserState) => state.user
);
